<template>
	<div>
		<div class="banner">
			<img class="dpname" src="../assets/dpname.png" />
			<div class="lobg_box">
				<div class="login" >
					<div class="nh">你好，欢迎登录</div>
					<input class="username" v-model="form.username" placeholder="请输入账号" />
					<input class="password" v-model="form.password" type="password" placeholder="请输入密码" />
					<div class="chename_box">
						<el-checkbox class="chename" v-model="rememberMe">
							记住账号
						</el-checkbox>
					</div>
					<div class="login_btn" @click="login">
						登录
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import CryptoJS from 'crypto-js'
	export default {
		data() {
			return {
				rememberMe: true,
				form: {
					username: '',
					password: ''
				},
                loading:false,
			}
		},
		created() {
			let account = localStorage.getItem('account')
			
			let token=JSON.parse(localStorage.getItem('Project-Token'))
			this.loading = true;
			axios.post(process.env.VUE_APP_BASE_API+'/adminUser/queryLoginUser',{1:1})			        
					.then((res)=>{
						if(res.data.code==0){
							this.getAxios('/adminRoleMenuDp/getByUser', {}, 'json').then(res => {
								let arr=Object.keys(res.data.data.construction)
								if(arr.length==0){
									this.$message({
							          message: '暂无权限,请联系管理员',
							          type: 'warning'
							        });
								}else{
									
							        this.$router.push('/index/home')
								}
							}).catch(err => {});
                            this.loading = false;
						}else{
                            this.loading = false;
						}

					})
					.catch((error)=>{
					    //  错误处理 相当于error
					    //this.$message.error(error);
                        this.loading = false;
					})
		},
		methods: {
			login() {
				if(this.form.username == '') {
					this.$message.error('请输入账号');
					return false
				} else if(this.form.password == '') {
					this.$message.error('请输入密码');
					return false
				} else {
					if(this.rememberMe) {
						localStorage.setItem('account','account',this.form.username)
					} else {
						localStorage.removeItem('account')
					}
					var key = CryptoJS.enc.Utf8.parse("qdoner1234567890");
			        var username = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.form.username), key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
			        var password = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.form.password), key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
			        var userInfoCopy= JSON.parse(JSON.stringify(this.form))
			        userInfoCopy.username = username.toString()
			        userInfoCopy.password = password.toString()
			        axios.post(process.env.VUE_APP_BASE_API+'/login',userInfoCopy)
			        
					.then((res)=>{
						if(res.data.code==0){
							this.$store.dispatch('pageDataReflushTime')
						  let token={'data':res.data.data.adminToken}			  					   	
						   localStorage.setItem('Project-Token',JSON.stringify(token))
						   this.setCookie('Admin-Token',res.data.data.adminToken,30)
							//web端
                            localStorage.setItem('Admin-Token',res.data.data.adminToken)
						  	
						  this.getAxios('/adminRoleMenuDp/getByUser', {}, 'json').then(res => {
								let arr=Object.keys(res.data.data.construction)
								if(arr.length==0){
									this.$message({
							          message: '暂无权限,请联系管理员',
							          type: 'warning'
							        });
								}else{
									
							        this.$router.push('/index/home')
								}
							}).catch(err => {});
						}else{
							this.$message.error(res.data.msg);
						}
					
					})
					.catch((error)=>{
						
					})
				}
			},
			setCookie(cname, cvalue, exdays) {
			    var d = new Date();
			    d.setTime(d.getTime() + (exdays*24*60*60*1000));
			    var expires = "expires="+d.toUTCString();
			    document.cookie = cname + "=" + cvalue + "; " + expires;
			}
		}
	}
</script>

<style scoped>
	.banner {
		overflow: hidden;
		height: 100vh;
		width: 100%;
		background: url(../assets/loginbanner.png) no-repeat;
		background-size: 100% 100%;
	}
	
	.dpname {
		display: block;
		margin: 0 auto;
		margin-top: 199px;
	}
	
	.lobg_box {
		width: 542px;
		height: 336px;
		margin: 0 auto;
		margin-top: 62px;
		background: url(../assets/lobg.png) no-repeat;
	}
	
	.login {
		width: 316px;
		margin: 0 auto;
		overflow: hidden;
	}
	
	.nh {
		color: #FFFFFF;
		font-weight: 600;
		font-size: 18px;
		margin-top: 34px;
	}
	
	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #A1D6FD;
	}
	
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #A1D6FD;
	}
	
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #A1D6FD;
	}
	
	input:-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #A1D6FD;
	}
	
	.username {
		width: 271px;
		height: 43px;
		color: #A1D6FD;
		background: linear-gradient(0deg, #2C387B, rgba(29, 56, 138, 0));
		border: 1px solid #4A93C1;
		border-radius: 5px;
		outline: none;
		font-size: 14px;
		background: url(../assets/user.png) no-repeat 12px center;
		padding-left: 43px;
		margin-top: 27px;
	}
	
	.password {
		width: 271px;
		height: 43px;
		color: #A1D6FD;
		background: linear-gradient(0deg, #2C387B, rgba(29, 56, 138, 0));
		border: 1px solid #4A93C1;
		border-radius: 5px;
		outline: none;
		font-size: 14px;
		background: url(../assets/password.png) no-repeat 12px center;
		padding-left: 43px;
		margin-top: 27px;
	}
	
	.chename_box {
		margin-top: 19px;
		text-align: right;
	}
	
	.chename {
		color: #FFFFFF;
	}
	
	.login_btn {
		width: 316px;
		height: 45px;
		background: #338DC4;
		border-radius: 5px;
		margin-top: 23px;
		text-align: center;
		line-height: 45px;
		color: #FEFEFE;
		font-size: 18px;
		cursor: pointer;
	}
</style>